import src from "IMAGE";
export default { src, width: 2900, height: 1822, blurWidth: 0, blurHeight: 0};
